export default {
  fiscalYears: [],
  loading: false
}
